var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"sidebar d-flex flex-column overflow-hidden",staticStyle:{"z-index":"1"},attrs:{"width":_vm.width,"tile":"","outlined":""}},[_vm._t("default",null,null,_vm.data)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }